import React from "react";
import { Alert } from "antd";

interface ImportWarningsProps {
  warnings?: string[];
}

/**
 * Lists the advisories an executed import returned in its summary's
 * `warnings`: things the operator has to act on that did not stop the import —
 * an adapter skipped for an unresolved conflict, a setting a legacy server
 * export (.dat) could not carry, a bank moved to another organization.
 * Renders nothing when there are none.
 */
export default function ImportWarnings({ warnings = [] }: ImportWarningsProps) {
  if (warnings.length === 0) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginTop: 16 }}
      message={`${warnings.length} import ${warnings.length === 1 ? "warning" : "warnings"}`}
      description={
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          {warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      }
    />
  );
}
